// @ts-nocheck

import { debounce } from 'lodash';
import { useEffect, useRef } from 'react';

import { Target } from '../client';

/**
 * triggers a callback when the `wheel` event occures
 *
 * @param {Function} handler the callback which fires when the `wheel` event occures
 * @param {number} delay the debounce delay when the `wheel` event ocurres
 */
const useDesktopHorizontalScroll = (handler: () => void, delay: number = 10) => {
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const touchStartY = useRef(0);
  const touchEndY = useRef(0);

  useEffect(() => {
    const onWheelHandler = debounce((e) => {
      const isHorizontal = Math.abs(e.deltaX) >= 1;
      if (isHorizontal && handler) {
        handler();
      }
    }, delay);

    const handleGesture = debounce(() => {
      const isSwipeLeft = touchEndX.current < touchStartX.current;
      const isSwipeRight = touchEndX.current > touchStartX.current;
      const isHorizontalSwipe = isSwipeLeft || isSwipeRight;

      if (isHorizontalSwipe && handler) {
        handler();
      }
    }, delay);

    const onTouchStartHandler = (e) => {
      // @see compatibility: https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent/changedTouches
      const changedTouches = e.changedTouches;
      const hasChangedTouches = changedTouches?.length;

      touchStartX.current = hasChangedTouches ? changedTouches[0]?.screenX : 0;
      touchStartY.current = hasChangedTouches ? changedTouches[0]?.screenY : 0;
    };

    const onTouchEndHandler = (e) => {
      const changedTouches = e.changedTouches;
      const hasChangedTouches = changedTouches?.length;

      touchEndX.current = hasChangedTouches ? changedTouches[0]?.screenX : 0;
      touchEndY.current = hasChangedTouches ? changedTouches[0]?.screenY : 0;

      handleGesture();
    };

    if (!Target.__MOBILE__) {
      window.addEventListener('wheel', onWheelHandler);

      // gesture for when we are in a desktop view from a mobile (IPAD for example)
      window.addEventListener('touchstart', onTouchStartHandler);
      window.addEventListener('touchend', onTouchEndHandler);

      return () => {
        window.removeEventListener('wheel', onWheelHandler);

        // gesture for when we are in a desktop view from a mobile (IPAD for example)
        window.removeEventListener('touchstart', onTouchStartHandler);
        window.removeEventListener('touchend', onTouchEndHandler);
      };
    }
  }, [handler, delay]);
};
export default useDesktopHorizontalScroll;
